import { Pause } from '@/components/icons/video/pause';
import { Play } from '@/components/icons/video/play';
import { Button } from './Button';
import { useVideoStore } from '../hooks/useVideoStore';
import { isMobile } from 'react-device-detect';
import { useIsMobileDevice } from '../hooks/useIsMobileDevice';

export function PlayPauseButton() {
  const { isPlaying, togglePlaying, toggleFullscreen } = useVideoStore(
    (state) => ({
      isPlaying: state.isPlaying,
      togglePlaying: state.togglePlaying,
      toggleFullscreen: state.toggleFullscreen,
    })
  );

  const isMobileDevice = useIsMobileDevice();

  function handleOnClick() {
    if (isMobile) {
      toggleFullscreen(isMobileDevice);
      togglePlaying();
    } else {
      togglePlaying();
    }
  }

  return (
    <Button
      label={isPlaying ? 'Pause video' : 'Play video'}
      icon={isPlaying ? <Pause /> : <Play />}
      onClick={handleOnClick}
    />
  );
}
